import { render } from "./InventoryStockTab.vue?vue&type=template&id=375649e2"
import script from "./InventoryStockTab.vue?vue&type=script&lang=js"
export * from "./InventoryStockTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__